<template>
    <div class="top_con">
       <el-form :inline="true" class="demo-form-inline">
           <el-row :gutter="10">
                <el-form-item label="姓名">
                    <el-input v-model="name"  placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="tel"  placeholder="请输入手机号"></el-input>
                </el-form-item>
                <div style="float:right;">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="clearS">重置</el-button>
                    </el-form-item>
                </div>
           </el-row>
        </el-form>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" max-height="600px">
            <el-table-column prop="num"  label="头像" >
                <template slot-scope="scope">
                    <el-image  style="width:40px;height:30px;margin:0 auto;" :src="scope.row.img" :preview-src-list="scope.row.imgs"></el-image>
                 </template>
            </el-table-column>
            <el-table-column  prop="nickname"  label="昵称"></el-table-column>
            <el-table-column prop="name"  label="姓名"></el-table-column>
            <el-table-column prop="tel"  label="手机号" ></el-table-column>
            <el-table-column prop="address"  label="所在地" ></el-table-column>
            <el-table-column prop="gangwei"  label="岗位" ></el-table-column>
            <el-table-column prop="company"  label="公司" ></el-table-column>

            <el-table-column   label="操作" style="text-align:center"> 
                <template slot-scope="scope">
                    <el-link :underline="false" @click="Edit(scope.row)" style="margin-right:20px;" size="small" v-if="true1==true">编辑</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
        <div>
            <el-dialog title="编辑用户信息" :visible.sync="dialogFormVisible_s" width="44%">
                 <el-form ref="form" :model="model" label-width="100px">
           <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="头像">
                    <img :src="model.img" alt="">
                    </el-form-item>
                </el-col>
             <el-col :span="8">
                    <el-form-item label="昵称">
                        <el-input v-model="model.nickname" disabled placeholder="请输入" class="inpt"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="姓名">
                        <el-input v-model="model.name" placeholder="请输入" class="inpt"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="手机号">
                        <el-input v-model="model.tel" placeholder="请输入" class="inpt"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="岗位">
                        <el-input v-model="model.gangwei" placeholder="请输入" class="inpt"></el-input>
                    </el-form-item>
                </el-col>
                      <el-col :span="8">
                    <el-form-item label="所在地">
                        <el-input v-model="model.address" placeholder="请输入" class="inpt"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="公司">
                        <el-input v-model="model.company" placeholder="请输入" class="inpt"></el-input>
                    </el-form-item>
                </el-col>
           </el-row>
      
              </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="onEdit">确认修改</el-button>
                    <el-button  @click="dialogFormVisible_s = false">取消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {getUserList,editInfo} from '@/utils/api'
export default {
    data(){
        return{
            user:{},
            houseLis:[],
            ckid:'',
            cknum:'',
            ps:[],
            ruKu:'',
            jieYu:'',
            zMoney:'',
            name:'',
            tel:'',
            jianjie:'',
            dialogFormVisible:false,
            dialogFormVisible_s:false,
            chuKu:false,
            model:{},
            tit_type:0,
            formLabelWidth: '120px',
            value:10,
            total:12,
            multipleSelection:[],
            tableData: [],
            fileList: [],
            pageNum:1,
            true1:false,
            psid:''
        }
    },
    methods:{
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                numPerPage:this.value,
                pageNum:val,
                userId:this.user.uid,
                name:this.name,
                tel:this.tel
            }
            getUserList(param).then(res=>{
                this.total=res.total,
                this.tableData=res.list
                if(res.qx.wxedit){
                    this.true1=true;
                }
            });
        },
        clearS(){
            this.name=''
            this.tel=''
            this.pageNum=1
            this.onSubmit()
        },
        Edit(item){
            this.dialogFormVisible_s=true
            this.model=item
        }, 
        onEdit(){
             editInfo(this.model).then(res=>{
                  this.$message({
                        type: 'success',
                        message: '编辑成功 '
                    });
                    this.getUser()
                    this.dialogFormVisible_s=false
    
            });
        },
        onSubmit(){
            let param ={
                pageNum:'1',
                numPerPage:this.value,
                userId:this.user.uid,
                name:this.name,
                tel:this.tel
            }
            getUserList(param).then(res=>{
                this.total=res.total,
                this.tableData=res.list
            });
        },
        getUser(){
              let param ={
               numPerPage:this.value,
                pageNum:this.pageNum,
                name:this.name,
                userId:this.user.uid,
                tel:this.tel
        }
        getUserList(param).then(res=>{
            this.total=res.total,
            this.tableData=res.list
                if(res.qx.wxedit){
                    this.true1=true;
                }
        });
        }
       
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
      this.getUser()
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
    .el-image{
        margin-right:30px;
    }
    .wenzi{
        width:100%;
        height:100px;
        border:2px solid #e5e5e5;
    }
    table{
        margin:0 auto;
        width:100%;
        margin: 0;
    }
    table,table tr td {
            border: 1px solid #DEDEDE;
            margin: 0;
            color: #000000;
            padding: 10px 10px;
            box-sizing:border-box;
            font-size: 14px;
            font-weight: 400;
			font-family: Microsoft YaHei;
            border-collapse: collapse;
            text-align:center;
        }
</style>



// WEBPACK FOOTER //
// src/components/wxUser.vue